import React from 'react';
import Link from 'next/link';

interface Props {
  data: any;
  children: React.ReactNode;
  alt?: string;
}

const CustomLink: React.FC<Props> = (props: any) => {
  const { data, children } = props
  return (
    <a href={data?.href || '/'} target={data?.target || null} aria-label={props?.alt}>
      {children}
    </a>
  )
}

export default CustomLink;